import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './DriverInformation.module.scss'
import { driverFirstNameAction } from 'redux/actions'
import { useDispatch, useSelector } from 'react-redux'

const DriverFirstName = ({ t, validateDriverFirstName, driverFirstNameError, driverFirstNameValid, setIsError }) => {
  const dispatch = useDispatch()
  const [isFocussed, SetIsFocussed] = useState(false)

  const driverFirstName = useSelector((state) => state.driver.driverInformation.driverFirstName)

  const handleDriverFirstName = (e) => {
    try {
      let name = e.currentTarget.value
      dispatch(driverFirstNameAction(name))
      validateDriverFirstName(name)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  const onBlurDriverFirstName = (e) => {
    try {
      SetIsFocussed(false)
      let name = e.currentTarget.value.trim()
      dispatch(driverFirstNameAction(name))
      validateDriverFirstName(driverFirstName)
    } catch (err) {
      console.log(err)
      setIsError(true)
    }
  }

  return (
    <div
      className={[
        driverFirstNameValid === true
          ? driverFirstName === ''
            ? ''
            : 'form-group has-success'
          : driverFirstNameValid === false
            ? 'form-group has-error'
            : '',
        styles['fields_margin'],
      ].join(' ')}
    >
      <label className="control-label" htmlFor="DriverFirstName">
        {t('driver_information.driver_first_name')}
      </label>
      <input
        type="text"
        id="DriverFirstName"
        className="form-control"
        value={driverFirstName}
        onChange={handleDriverFirstName}
        onBlur={onBlurDriverFirstName}
        onFocus={() => SetIsFocussed(true)}
        autoComplete="off"
        maxLength="150"
      />
      {driverFirstNameValid === true ? (
        driverFirstName === '' ? (
          ''
        ) : (
            <i className={['fa fa-check-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          )
      ) : driverFirstNameValid === false ? (
        <React.Fragment>
          <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
          <div className={isFocussed ? 'help-block-focused' : 'help-block'}>{t(driverFirstNameError)}</div>
        </React.Fragment>
      ) : (
            ''
          )}
    </div>
  )
}

export default withTranslation('common')(DriverFirstName)
